var exports = {
  "E": "Text__9IZjHH",
};

module.exports = exports;
